// Zet een ruwe property-key (bv. 'page_displayName', 'projectName') om naar een leesbaar label
// ('Page display name', 'Project name'). Centrale plek: een latere i18n-stap (bv. Transloco-key
// 'filterField.<field>' met deze humanize als fallback) hoeft alleen hier te haken.
export function humanizeFieldName(field: string): string {
    if (!field) return '';

    const _words = field
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')   // camelCase → camel Case
        .replace(/[_\-.]+/g, ' ')                  // scheidingstekens → spatie
        .trim()
        .toLowerCase();

    return _words.charAt(0).toUpperCase() + _words.slice(1);
}
